export enum ThemeFonts {
  Main = 'main',
}
